<template>
  <v-main align="center">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <v-card class="elevation-12">
            <ConnectorToolbar :title="$t('connector.toolbarTitle')" />
            <router-view></router-view>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import ConnectorToolbar from "@/components/connectors/ConnectorToolbar";

export default {
  name: "ConnectorView",
  data() {
    return {};
  },

  components: {
    ConnectorToolbar
  }
};
</script>